<template>
  <div class="carteira-cadastro-departamentos-vue carteira-cadastros-vue mt-3">
    <div class="carteira-cadastros-vue__bootstrap-modals">
      <Modal
        modal-id="modalCarteiraCadastroDepartamentosErro"
        :title="errorModalTitle"
        dialog-class="modal-dialog-centered"
      >
        <template #body>
          <p v-if="errorModalMessage" class="mb-2">{{ errorModalMessage }}</p>
          <ul
            v-if="errorModalItems.length"
            class="list-unstyled mb-0 carteira-cadastros-vue__error-list"
          >
            <li v-for="(row, i) in errorModalItems" :key="i" class="small">
              <template v-if="row.label">
                <strong>{{ row.label }}:</strong>
                {{ row.text }}
              </template>
              <template v-else>{{ row.text }}</template>
            </li>
          </ul>
        </template>
        <template #footer>
          <button type="button" class="btn btn-primary btn-sm" @click="closeErrorModal">Fechar</button>
        </template>
      </Modal>

      <Modal
        modal-id="modalCarteiraCadastroDepartamentosExcluir"
        title="Excluir registro"
        dialog-class="modal-dialog-centered"
      >
        <template #body>
          <p v-if="deleteTarget" class="mb-0">
            {{ deleteConfirmText }}
          </p>
        </template>
        <template #footer>
          <Button variant="danger" size="sm" :loading="deleteDeleting" @click="executeDeleteConfirmed">
            {{ deleteDeleting ? "Excluindo…" : "Excluir" }}
          </Button>
          <button
            type="button"
            class="btn btn-secondary btn-sm ml-2"
            :disabled="deleteDeleting"
            data-dismiss="modal"
            @click="closeDeleteConfirmModal"
          >
            Cancelar
          </button>
        </template>
      </Modal>

      <Modal modal-id="modalCarteiraCadastroDepartamentosItem" :title="modalTitle" dialog-class="modal-lg">
        <template #body>
          <Input
            v-model="form.nome"
            name="nome"
            id="carteira-cadastro-departamento-nome"
            label="Nome"
            placeholder="Nome"
            required
          />
          <Input
            v-model="ordemStr"
            name="ordem"
            id="carteira-cadastro-departamento-ordem"
            label="Ordem"
            type="number"
          />
          <div class="mb-3">
            <Check v-model="form.ativo">Ativo</Check>
          </div>
          <p v-if="formError" class="text-danger small mb-0">{{ formError }}</p>
        </template>
        <template #footer>
          <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button>
          <Button variant="primary" size="sm" :loading="saving" @click="saveModal">Salvar</Button>
        </template>
      </Modal>
    </div>

    <div v-if="!localUsuarioPodeCadastro" class="alert alert-warning">
      Somente administradores ou gerentes podem gerenciar estes cadastros.
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap carteira-cadastros-vue__toolbar">
      <h5 class="mb-0 campanha-interna-campanhas-vue__title"></h5>
      <Button
        v-if="localUsuarioPodeCadastro"
        variant="success"
        size="sm"
        depth
        @click="openEditModal(null)"
      >
        <Icon type="fas" icon="plus" color="white" class="mr-1" />
        Adicionar
      </Button>
    </div>

    <div v-if="loading" class="text-center py-4">Carregando...</div>
    <div v-else class="carteira-cadastros-vue__card carteira-cadastros-vue__datatable-wrap">
      <DataTable
        name="Departamentos"
        :headers="headers"
        :data="items"
        :pesquisa="true"
        :options="tableOptions"
        :itens-per-page-options="[10, 20, 30, 50, 100, -1]"
      >
        <template v-slot:[`item.ativo`]="{ item }">
          <span
            class="campanha-interna-vue-status-pill"
            :class="
              isAtivo(item)
                ? 'campanha-interna-vue-status-pill--ativa'
                : 'campanha-interna-vue-status-pill--inativa'
            "
          >
            {{ isAtivo(item) ? "Ativo" : "Inativo" }}
          </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex justify-content-end align-items-center flex-wrap carteira-cadastros-vue__row-actions">
            <Button
              v-if="localUsuarioPodeCadastro"
              variant="primary"
              size="sm"
              table
              class="mr-1 mb-1"
              title="Editar"
              @click="openEditModal(item)"
            >
              <i class="fas fa-edit"></i>
            </Button>
            <Button
              v-if="localUsuarioPodeCadastro"
              variant="danger"
              size="sm"
              table
              class="mb-1"
              title="Excluir"
              @click="openDeleteConfirmModal(item)"
            >
              <i class="fas fa-trash"></i>
            </Button>
          </div>
        </template>
      </DataTable>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DataTable from "../../ui/DataTable.vue";
import Input from "../../ui/Input.vue";
import Check from "../../ui/Check.vue";
import Icon from "../../ui/Icon.vue";
import Button from "../../ui/Button.vue";
import Modal from "../../ui/Modal.vue";

const JSON_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Requested-With": "XMLHttpRequest",
};

function fieldLabel(key) {
  const map = {
    nome: "Nome",
    ordem: "Ordem",
    ativo: "Ativo",
  };
  return map[key] || String(key).replace(/_/g, " ");
}

/** Bootstrap `.modal` está no jQuery global (carregado depois do app.js), não no import do webpack. */
function bs$(selector) {
  const jq = typeof window !== "undefined" ? window.jQuery || window.$ : null;
  if (!jq) {
    return { modal: () => {} };
  }
  return jq(selector);
}

export default {
  name: "CarteiraCadastroDepartamentosApp",
  components: {
    DataTable,
    Input,
    Check,
    Icon,
    Button,
    Modal,
  },
  data() {
    return {
      localApiUrls: {},
      localUsuarioPodeCadastro: false,
      items: [],
      loading: false,
      saving: false,
      tableOptions: {
        page: 1,
        itemsPerPage: 30,
      },
      editingId: null,
      form: { nome: "", ordem: null, ativo: true },
      formError: "",
      errorModalTitle: "Atenção",
      errorModalMessage: "",
      errorModalItems: [],
      deleteTarget: null,
      deleteDeleting: false,
      headers: [
        { text: "#", value: "id", sortable: true, width: "72px" },
        { text: "Nome", value: "nome", sortable: true },
        { text: "Ordem", value: "ordem", sortable: true },
        { text: "Ativo", value: "ativo", sortable: true },
        { text: "Ações", value: "actions", sortable: false, align: "end", width: "120px" },
      ],
    };
  },
  computed: {
    modalTitle() {
      const action = this.editingId ? "Editar" : "Novo";
      return `${action} departamento`;
    },
    ordemStr: {
      get() {
        const o = this.form.ordem;
        if (o === null || o === undefined || o === "") return "";
        return String(o);
      },
      set(v) {
        if (v === "" || v === null || v === undefined) {
          this.form.ordem = null;
          return;
        }
        const n = Number(v);
        this.form.ordem = Number.isNaN(n) ? null : n;
      },
    },
    deleteConfirmText() {
      if (!this.deleteTarget) return "";
      const nome = this.deleteTarget.nome || `#${this.deleteTarget.id}`;
      return `Excluir este departamento "${nome}"? Esta ação não pode ser desfeita.`;
    },
  },
  mounted() {
    const cfg = typeof window !== "undefined" ? window.carteiraCadastroConfig || {} : {};
    const urls = cfg.apiUrls && Object.keys(cfg.apiUrls).length ? cfg.apiUrls : {};
    const token = cfg.csrfToken || "";
    const pode =
      cfg.usuarioPodeCadastro !== undefined ? !!cfg.usuarioPodeCadastro : false;

    this.localApiUrls = urls;
    this.localUsuarioPodeCadastro = pode;

    axios.defaults.headers.common["X-CSRF-TOKEN"] = token;
    axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

    this.loadList();
  },
  methods: {
    isAtivo(item) {
      const s = item && item.ativo;
      if (s === true || s === 1 || s === "1") return true;
      if (s === false || s === 0 || s === "0") return false;
      return !!s;
    },
    showErrorModal({ title, message, errors }) {
      this.errorModalTitle = title || "Atenção";
      this.errorModalMessage = message || "";
      this.errorModalItems = [];
      if (errors && typeof errors === "object" && !Array.isArray(errors)) {
        Object.keys(errors).forEach((key) => {
          const msgs = errors[key];
          const arr = Array.isArray(msgs) ? msgs : [msgs];
          const label = fieldLabel(key);
          arr.forEach((m) => {
            if (m != null && String(m).trim() !== "") {
              this.errorModalItems.push({ label, text: String(m) });
            }
          });
        });
      }
      if (!this.errorModalMessage && this.errorModalItems.length) {
        this.errorModalMessage = "Corrija os campos indicados abaixo.";
      }
      this.$nextTick(() => {
        bs$("#modalCarteiraCadastroDepartamentosErro").modal("show");
      });
    },
    closeErrorModal() {
      bs$("#modalCarteiraCadastroDepartamentosErro").modal("hide");
    },
    openDeleteConfirmModal(item) {
      this.deleteTarget = item;
      this.deleteDeleting = false;
      this.$nextTick(() => {
        bs$("#modalCarteiraCadastroDepartamentosExcluir").modal("show");
      });
    },
    closeDeleteConfirmModal() {
      bs$("#modalCarteiraCadastroDepartamentosExcluir").modal("hide");
      this.deleteTarget = null;
    },
    async loadList() {
      this.loading = true;
      try {
        const { data } = await axios.get(this.localApiUrls.departamentos, {
          headers: JSON_HEADERS,
        });
        this.items = Array.isArray(data) ? data : [];
      } catch (e) {
        console.error(e);
        this.items = [];
        this.showErrorModal({
          title: "Lista",
          message: "Não foi possível carregar os dados.",
        });
      } finally {
        this.loading = false;
      }
    },
    openEditModal(row) {
      this.formError = "";
      this.editingId = row ? row.id : null;
      this.form = {
        nome: row ? row.nome : "",
        ordem: row ? row.ordem : null,
        ativo: row ? this.isAtivo(row) : true,
      };
      this.$nextTick(() => {
        bs$("#modalCarteiraCadastroDepartamentosItem").modal("show");
      });
    },
    async saveModal() {
      this.formError = "";
      this.saving = true;
      try {
        const payload = {
          nome: this.form.nome,
          ordem:
            this.form.ordem === null || this.form.ordem === "" ? null : Number(this.form.ordem),
          ativo: !!this.form.ativo,
        };
        const base = this.localApiUrls.departamentoBase;
        if (this.editingId) {
          await axios.put(`${base}/${this.editingId}`, payload, { headers: JSON_HEADERS });
        } else {
          await axios.post(base, payload, { headers: JSON_HEADERS });
        }
        bs$("#modalCarteiraCadastroDepartamentosItem").modal("hide");
        await this.loadList();
      } catch (e) {
        const d = e.response && e.response.data ? e.response.data : {};
        if (e.response && e.response.status === 422) {
          this.showErrorModal({
            title: "Dados inválidos",
            message: d.message || "Os dados enviados são inválidos.",
            errors: d.errors,
          });
        } else {
          const msg =
            (typeof d.message === "string" && d.message) ||
            (typeof d.error === "string" && d.error) ||
            "Não foi possível salvar.";
          this.formError = typeof msg === "string" ? msg : JSON.stringify(msg);
        }
      } finally {
        this.saving = false;
      }
    },
    async executeDeleteConfirmed() {
      if (!this.deleteTarget) {
        this.closeDeleteConfirmModal();
        return;
      }
      const id = this.deleteTarget.id;
      this.deleteDeleting = true;
      try {
        await axios.delete(`${this.localApiUrls.departamentoBase}/${id}`, {
          headers: JSON_HEADERS,
        });
        this.closeDeleteConfirmModal();
        await this.loadList();
      } catch (e) {
        this.closeDeleteConfirmModal();
        const d = e.response && e.response.data ? e.response.data : {};
        this.showErrorModal({
          title: "Exclusão",
          message:
            (typeof d.message === "string" && d.message) || "Não foi possível excluir este registro.",
        });
      } finally {
        this.deleteDeleting = false;
      }
    },
  },
};
</script>

<style scoped>
.carteira-cadastros-vue__toolbar {
  gap: 0.5rem;
}

.carteira-cadastros-vue__error-list li + li {
  margin-top: 0.35rem;
}

.carteira-cadastros-vue__datatable-wrap ::v-deep .container-fluid {
  padding-left: 0;
  padding-right: 0;
}
</style>
